<div class="videoviewer-container">
  <video controls>
    <source [src]="data.videoUrl" type="video/mp4">
    The video player is not supported by your browser.
  </video>
</div>
